function matchesReferralSensitivity(serviceType, forwardReferralParams) {
  if ((forwardReferralParams === null || forwardReferralParams === void 0 ? void 0 : forwardReferralParams.referralType) === 'inbound') {
    if (forwardReferralParams.sensitive) {
      return serviceType.is_sensitive;
    }
    return !serviceType.is_sensitive;
  }
  // Everything is selectable by default
  return true;
}
export default matchesReferralSensitivity;
//# sourceMappingURL=matchesReferralSensitivity.js.map